import React from 'react';
import {Dialog, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from '.././styles.module.scss';
import {useEffect, useState} from 'react';
import {AnnouncementItems} from '../consts/types';
import {sendAnalyticsMonitor} from '../../../utils/monitoring';
import {Footer} from './Footer';
import {DialogContent} from './DialogContent';
import {texts} from '../data/v24texts';
import {ModernTooltip} from '../../../components/Common/Tooltip/ModernTooltip';

interface AnnouncementDialogPrpos {
    announcement: AnnouncementItems[];
    onClose: () => void;
    toWelcomePage?: (arg: boolean) => void;
}
export const AnnouncementDialog = (props: AnnouncementDialogPrpos) => {
    const {announcement, onClose, toWelcomePage} = props;
    const [curPageIndex, setCurPageIndex] = useState(0);
    const {content, title, additionalContent, monitoring, linkText, linkUrl, lottieContent} =
        announcement[curPageIndex];
    const pagesCounter = announcement.length;
    const isLastPage = curPageIndex === pagesCounter - 1;
    const forwardBtnText = isLastPage ? texts.finalStep : texts.nextBtn;
    const backwardsBtnText = texts.backBtn;

    useEffect(() => {
        const logoImg = new Image();
        logoImg.src = `${window['baseUrl']}/images/logo_black.svg`;
    }, []);

    const onForward = () => {
        setCurPageIndex(curPageIndex + 1);
    };

    const handleConfirmBtn = () => {
        if (monitoring?.forwardBtn) {
            sendAnalyticsMonitor(monitoring.forwardBtn);
        }
        isLastPage ? onClose() : onForward();
    };

    const handleBackBtn = () => {
        curPageIndex ? setCurPageIndex(curPageIndex - 1) : toWelcomePage(true);
    };

    const handleClose = () => {
        if (monitoring?.closeBtn) {
            sendAnalyticsMonitor(monitoring.closeBtn);
        }
        onClose();
    };

    return (
        <Dialog
            size="small"
            width={640}
            isOpen={true}
            closeIcon={
                <ModernTooltip position="top" tooltip={texts.closeTooltip}>
                    <Icon icon={PriorityIcon.closeSmall} />
                </ModernTooltip>
            }
            componentClasses={styles.dialog}
            onClose={handleClose}
            content={
                <DialogContent
                    isWelcomePage={false}
                    content={content}
                    title={title}
                    additionalContent={additionalContent}
                    lottieContent={lottieContent}
                    linkText={linkText}
                    linkUrl={linkUrl}
                />
            }
            footer={
                <Footer
                    dotsCounter={pagesCounter}
                    curPageIndex={curPageIndex}
                    isWelcomePage={false}
                    handleConfirmBtn={handleConfirmBtn}
                    handleBackBtn={handleBackBtn}
                    forwardBtnText={forwardBtnText}
                    backwardsBtnText={backwardsBtnText}
                />
            }
        />
    );
};
